export const infinityScrollPageSize = 18

/*
TODO!!!
 Temporary values, remove these at a later stage.
 Preferably these category IDs 
 should have a takebackbanner boolean
 coming from product API
*/
export const TAKEBACK_BANNER_CATEGORY_IDS = new Set([
  /* FILTER_PAGE */
  /* Laptops */
  '2029816', //Portable computers
  '2030144', //Business laptops
  '2030154', //Workstation laptops
  '2030142', //Apple MacBook
  '2439761', //Gaming laptops
  '2030152', //Ultrabooks
  '2267756', //2-in-1
  '2030150', //Everyday laptops
  '8268693', //Pre-owned
  '2030146', //Chromebooks

  /* Tablets */
  '2029818', //Tablets
  '2030160', //Apple iPad
  '2030158', //Android tablets
  '8268703', //Pre-owned tablets

  /* Desktop computers */
  '2029814', //Desktop computers
  '2030132', //Business Desktop PC
  '2030138', //Workstation
  '2030128', //Apple Mac
  '2030134', //Thin Clients
  '2030136', //Gaming
  '8268720', //Pre-owned

  /* Displays & accessories */
  '2029782', //Displays & accessories
  '2084696', //Displays
  '2030170', //Digital Signage
  '2921965', //Gaming displays

  /* Smartphones */
  '2030102', //Smartphones
  '2031016', //Android
  '2106305', //Apple iPhone
  '67886460', //Pre-owned

  /* CATEGORY_PAGE */
  '2037749', //Computer & Tablets
  '2037751', //Computer Accessories / Monitor & Computer Accessories
  '2029810', //Phones & GPS
])

export const HARDWARE_CATEGORY_ID = '2037738'

export const newProductsOnlyFacets = [
  { name: 'showonly', values: ['isnewproduct'] },
  { name: 'isnewproduct', values: ['true'] },
]
